import React, { useEffect, useState } from "react"
import { useHistory, useParams } from "react-router"
import moment from "moment"
import { useTheme } from "@emotion/react"
import { styles } from "../../../resources/styles/Styles"
import { PatientDetailStyles } from "../../../resources/styles/pages/PatientDetailStyles"
import {
  getPatientDetail,
  getMedicalRecordByAppointmentId,
  updateAppointment,
  getAppointmentsByQuery,
  updateNewPatient,
  getSmartSummaryData,
  getAllTestRMO,
  getInvoiceDetailsById,
  addInvoiceLink
} from "../../../core/services/api"
import { IPatient } from "../../../core/services/models/Patient"
import { IAppointmentDetail } from "../../../core/services/models/AppointmentDetail"
import PatientProfileCard from "../../../components/PatientProfileCard"
import Toast from "../../../components/Toast"
import { useSelector } from "react-redux"
import PermissionUtils from "../../../core/store/utils/PermissionUtils"
import UpcomingAppointmentCarousel from "../../../components/UpcomingAppointmentCarousel/UpcomingAppointmentCarousel"
import { MocUserRole } from "../../../core/services/models/Enums"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import Button from "components/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileAlt,
  faArrowDown
} from "@fortawesome/free-solid-svg-icons"
import fileUtils from "fileUtils"

function PatientDetail() {
  const [accordion, updateAccordion] = React.useState<any | null>()
  const [patientDetail, updatePatientDetail] = React.useState<IPatient>()
  const [displayToast, toggleDisplayToast] = React.useState<any>()
  const [
    pastAppointments,
    updatePastAppointments,
  ] = React.useState<Array<IAppointmentDetail> | []>([])
  const [upcomingAppointments, updateUpcomingAppointments] = React.useState<
    Array<IAppointmentDetail> | []
  >([])

  const [pastAppointmentDetail, updatePastAppointmentDetail] = React.useState<
    any | null
  >()
  const [smartSummary, updateSmartSummary] = useState<any>()
  const [isActive, setActive] = useState<any>(false)
  const [isAlive, setAlive] = useState<any>(false);
  const [isFollowup, setFollowup] = useState<any>()
  const [medicalrecordId, setMedicalRecordId] = useState<any>()
  const [selectedAppointment, setSelectedAppointment] = useState<any>()
  const [prescriptionsList, setPrescriptionsList] = useState<any>([])
  const [testsList, setTestsList] = useState<any>([])
  const [clickOrigin, setClickOrigin] = useState<any>("")
  const [show, setShow] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>()
  const [getInvoices, setInvoices] = useState<any>()
  const [required, setRequired] = useState<any>()
  const [sendPaymentLink, setSendPaymentLink] = useState<any>()
  const [patientDod, setPatientDod] = useState<Date>(new Date())

  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = PatientDetailStyles(theme)
  const history = useHistory()
  const { patientId }: any = useParams()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const element = document.getElementById("patientDetailWrapper")

  function onPatientAccountChange(sts: any, textArea: any) {
    let temp: any = { ...patientDetail };
    temp["accountStatus"] = sts;
    temp["reasonForInactivatingAccount"] = textArea;
    temp["lostToFollowUp"] = false
    temp["accountInactivatedOn"] = moment().format("YYYY-MM-DD")
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setActive(false)
      toggleDisplayToast(null)
    })
  }

  function onPatientFollowupChange(textArea: any) {
    let temp: any = { ...patientDetail };
    temp["lostToFollowUp"] = true;
    temp["lostToFollowUpReason"] = textArea
    temp["followedUpDate"] = moment().format("YYYY-MM-DD")
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setFollowup(false)
      toggleDisplayToast(false)
    })
  }

  function onPatientStatusChange() {
    let temp: any = { ...patientDetail };
    temp["survivalStatus"] = isAlive ? "Deceased" : "Alive";
    temp["accountStatus"] = isAlive ? "inactive" : "active";
    temp["dod"] = isAlive ? moment().format("YYYY-MM-DD") : null;
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setAlive(!isAlive)
      toggleDisplayToast(false)
    })
  }

  function onPatientDODChange() {
    let temp: any = { ...patientDetail };
    temp["dod"] = !isAlive ? patientDod : null;
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setPatientDod(patientDod)
      toggleDisplayToast(false)
    })
  }

  function fetchPastAppointments() {
    getAppointmentsByQuery(
      `pastOrUpcoming=PAST&patientId=${patientId || userDetail?.id}&sort=scheduleDate&order=DESC`
    )
      .then((res) => updatePastAppointments(res?.filter(
        item =>
          item?.status === 'COMPLETED',
      )))
      .catch((err) => {
        console.error("err", err)
      })
  }

  function fetchUpcomingAppointments() {
    getAppointmentsByQuery(
      `pastOrUpcoming=UPCOMING&patientId=${patientId || userDetail?.id}`
    )
      .then((res) =>
        updateUpcomingAppointments(
          res?.filter((each: any) => each?.status !== "CANCELLED")
        )
      )
      .catch((err) => {
        console.error("err", err)
      })
  }

  function fetchPatientDetail() {
    getPatientDetail(patientId || userDetail?.id)
      .then((res) => {
        updatePatientDetail(res)
      })
      .catch((err) => {
        console.error("err", err)
      })
  }

  function handleChange(panel: any) {
    updateAccordion(panel !== accordion ? panel : false)
    if (panel !== accordion && pastAppointments && pastAppointments[panel]) {
      getMedicalRecordByAppointmentId(pastAppointments[panel]?.id)
        .then((res) => {
          updatePastAppointmentDetail(res)
        })
        .catch((err) => {
          console.error("err", err)
          updatePastAppointmentDetail(null)
        })
    }
  }

  const handleMaintainPayment = () => {
    addInvoiceLink(getInvoices, required?.pendingAmount).then((res) => {
      setSendPaymentLink({
        type: "success",
        text: `Payment link sent via sms`,
      })
    })
      .catch((err) => {
        console.error(err?.response?.data?.message, "Payment Gatewayyy error");
        setSendPaymentLink({
          type: "error",
          text: `Please specify the amount to send online link to patient`
        })
      })
  }

  function renderAccordion(
    eachPastAppointment: any,
    index: number
  ) {
    return (
      <>
        <div className={classes.accordion}>
          <div className={`${classes.accordionHeader} col-md-12 row p-0 m-0`}>
            <div className={`col-md-7 col-lg-6 p-0`}>
              <div className={`${classes.accordionHeaderSpacing} d-flex`}>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitle}>Location</div>
                  <div className={classes.appContentValue}>
                    {eachPastAppointment?.centerName
                      ? eachPastAppointment?.centerName
                      : "-"}
                  </div>
                </div>
                <div className="col-md-5 p-0">
                  <div className={classes.appContentTitle}>Consultant</div>
                  <div className={classes.appContentValue}>
                    {eachPastAppointment?.consultantName
                      ? eachPastAppointment?.consultantName
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2.5 p-0">
                  <div className={classes.appContentTitle}>Date</div>
                  <div className={`${classes.appContentValue}`}>
                    {eachPastAppointment?.scheduleDate
                      ? moment(eachPastAppointment?.scheduleDate).format(
                        "DD-MM-YYYY"
                      )
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2.5 p-0">
                  <div className={classes.appContentTitle}>Slot</div>
                  <div className={`${classes.appContentValue}`}>
                    {eachPastAppointment?.allottedBed?.slots?.length > 0 ? moment(eachPastAppointment?.allottedBed?.slots[0], "HH:mm").format(
                      "hh:mm A"
                    ) : eachPastAppointment?.slots && eachPastAppointment?.slots[0]
                      ? moment(eachPastAppointment?.slots[0], "HH:mm").format(
                        "hh:mm A"
                      )
                      : "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className={`col-md-5 col-lg-6 p-0`}>
              <div className={`${classes.accRightSection}`}>
                <div className={`${classes.pl10} ${classes.appContentTitle}`}>
                  Prescription
                </div>
                <div className={`${classes.pl10} ${classes.appContentValueSelection}`}
                  onClick={() => {
                    setClickOrigin("prescriptions")
                    if (eachPastAppointment?.id) {
                      setMedicalRecordId(eachPastAppointment?.id)
                    } else {
                      setMedicalRecordId("")
                      setPrescriptionsList([])
                    }
                    setShow(true)
                  }}
                >
                  <img
                    src={"../../../assets/images/prescriptionIcon.svg"}
                    alt="prescriptionIcon"
                  />
                </div>
                <div className={`${classes.pl10} ${classes.appContentTitle}`}>
                  Lab Reports
                </div>
                <div className={`${classes.pl10} ${classes.appContentValueSelection}`}
                  onClick={() => {
                    setClickOrigin("tests")
                    if (eachPastAppointment?.id) {
                      setSelectedAppointment(eachPastAppointment?.id)
                    } else {
                      setSelectedAppointment("")
                      setTestsList([])
                    }
                    setShow(true)
                  }}
                >
                  <img
                    src={"../../../assets/images/labReportIcon.svg"}
                    alt="labReportIcon"
                  />
                </div>
                <div className={`${classes.pl30}`}>
                  <img
                    className={globalStyles.pointer}
                    src={
                      accordion === index
                        ? "../../../assets/images/chevronUpIcon.svg"
                        : "../../../assets/images/chevronDownIcon.svg"
                    }
                    alt={accordion === index ? "upArrow" : "downArrow"}
                    onClick={() => handleChange(index)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {accordion === index && (
          <div className={`${classes.accordionContent}`}>
            {pastAppointmentDetail ? (
              <>
                {renderAccordionContentRow(
                  "Medicines Prescribed",
                  pastAppointmentDetail?.followUpInfo?.prescriptionPad,
                  "medicineName"
                )}
                {renderAccordionContentRow(
                  "Lab Reports Prescribed",
                  pastAppointmentDetail?.followUpInfo?.testsRequired,
                  "testName"
                )}
                {renderAccordionContentRow(
                  "Advice",
                  pastAppointmentDetail?.followUpInfo?.advice
                )}
                {renderAccordionContentRow(
                  "Next Visit",
                  moment(pastAppointmentDetail?.followUpInfo?.nextVisit).format("DD-MM-YYYY"),
                  "",
                  true
                )}
                {userRole === MocUserRole.PATIENT && <div className="d-flex justify-content-center align-items-center m-2">
                  <Button text="Pay Now" onClick={() => handleMaintainPayment()} />
                </div>}

              </>
            ) : (
              <div className={classes.noDataState}>No data available.</div>
            )}
          </div>
        )}
      </>
    )
  }

  function renderAccordionContentRow(
    title: string,
    content: any,
    of: string = "",
    lastItem: boolean = false
  ) {
    return (
      <div className="col-md-12 m-0 p-0 row">
        <div className={`${globalStyles.relative}`}>
          <div className={classes.dividerLine} style={{ minHeight: lastItem ? "80px" : "111px" }} />
        </div>

        <div className={`${classes.accordionEachRow} col-md-12 m-0 p-0 row`}>
          <div
            className={`${globalStyles.pl0} ${globalStyles.pr0} text-center ${classes.dividerSection}`}
          >
            <img
              alt="green circle"
              src={"../../../assets/images/greenCircleIcon.svg"}
            />
          </div>
          <div className={`col-5 p-0 ${!lastItem && classes.btmBorder}`}>
            <div
              className={`${classes.dataContent} ${classes.appContentValue}`}
            >
              {title}
            </div>
          </div>
          <div className={`col-6 p-0 ${!lastItem && classes.btmBorder}`}>
            <div className={`${classes.dataContent}`}>
              {content instanceof Array ? content?.map((eachContent: any, index: number) => (
                <div key={`${title}-${index}`}>
                  <span className={classes.appContentValue}>{index + 1}. </span>{" "}
                  {of ? eachContent[of] : ""}
                </div>
              )) : <div>{content}</div>}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function onStatusChange(
    eachAppointment: any,
    status: string,
    redirectTo: any = null
  ) {
    let tempAppointment = Object.assign({}, eachAppointment)
    tempAppointment.status = status

    delete tempAppointment["patientName"]
    delete tempAppointment["gender"]
    delete tempAppointment["age"]
    delete tempAppointment["primaryPhoneNumber"]
    delete tempAppointment["email"]
    delete tempAppointment["isVIP"]
    delete tempAppointment["allottedBed"]
    delete tempAppointment["invoiceId"]
    delete tempAppointment["isEditable"]
    delete tempAppointment["dob"]
    delete tempAppointment["medicalRecordsId"]
    delete tempAppointment["bedIsVacant"]
    delete tempAppointment["bedMadeVacantAt"]
    delete tempAppointment["mocAppointmentId"]
    delete tempAppointment["oldDocuments"]
    delete tempAppointment["serviceName"]
    delete tempAppointment["finalInvoiceAmount"]

    if (redirectTo === "rescheduled") {
      tempAppointment["isRescheduled"] = true
      tempAppointment["isRescheduledAndCancelled"] = true
    }
    updateAppointment(tempAppointment)
      .then((res) => {
        if (redirectTo === "rescheduled") {
          history.push(
            `/bookAppointment?patientId=${eachAppointment?.patientId}&appointmentId=${eachAppointment?.id}`
          )
        } else {
          fetchUpcomingAppointments()
          toggleDisplayToast({
            text: `Appointment has been rejected successfully.`,
            type: "success",
          })
        }
      })
      .catch((err) => {
        console.error("err in appointment status change", err)
        toggleDisplayToast({
          text: "Unable to update appointment",
          type: "error",
        })
      })
  }

  function fetchSmartSummary(patientId: any) {
    getSmartSummaryData(patientId)
      .then((res: any) => {
        updateSmartSummary(res?.data)
      })
      .catch((err: any) => {
        console.error(err?.message)
      })
  }

  const getTNM = (row: any, index: any) => {
    const keys = Object.keys(row)
    if (keys.length > 0) {
      const stageKey = keys.find((e: any) => e.includes("csStage"))
      const tKey = keys.find((e: any) => e.includes("csPrimaryTumor"))
      const nKey = keys.find((e: any) => e.includes("RegionalLymphNodes"))
      const mKey = keys.find((e: any) => e.includes("csDistantMetastasis"))

      return (
        <>
          <span className="keys">Stage: </span>
          <span style={{ marginRight: "20px" }}>
            {row[`${stageKey}`] ? row[`${stageKey}`] : "NA"},
          </span>
          <span className="keys">T: </span>
          <span style={{ marginRight: "20px" }}>
            {row[`${tKey}`] ? row[`${tKey}`] : "NA"},
          </span>
          <span className="keys">N: </span>{" "}
          <span style={{ marginRight: "20px" }}>
            {row[`${nKey}`] ? row[`${nKey}`] : "NA"},
          </span>
          <span className="keys">M: </span>{" "}
          <span style={{ marginRight: "20px" }}>
            {row[`${mKey}`] ? row[`${mKey}`] : "NA"}
          </span>
          <span>{row?.cancerType}</span>
        </>
      )
    }
  }

  useEffect(() => {
    if (element) {
      element?.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])

  useEffect(() => {
    if (patientDetail && Object.keys(patientDetail)?.length > 0) {
      setActive(patientDetail?.accountStatus?.toLowerCase() === "active" ? true : false)
      setAlive(patientDetail?.survivalStatus?.toLowerCase() === "deceased" || patientDetail?.survivalStatus?.toLowerCase() === "dead" ? false : true)
      setFollowup(patientDetail?.lostToFollowUp ? true : false)
      setPatientDod(new Date(patientDetail?.dod))
    }
  }, [patientDetail])

  useEffect(() => {
    fetchPatientDetail()

    fetchUpcomingAppointments()

    fetchPastAppointments()

  }, [patientId])

  useEffect(() => {
    if (medicalrecordId) {
      getMedicalRecordByAppointmentId(medicalrecordId)
        .then((res: any) => {
          if (res?.prescriptionDocument) {
            if (Object.keys(res?.prescriptionDocument)) {
              const values = []
              const urlObj = { name: res?.prescriptionDocument?.name, date: res?.prescriptionDocument?.createdAt, blobUrl: res?.prescriptionDocument?.blobUrl }
              values.push(urlObj)
              setPrescriptionsList(values)
              setIsLoading(false)
            } else {
              setPrescriptionsList([])
              setIsLoading(false)
            }
          } else {
            setPrescriptionsList([])
            setIsLoading(false)
          }
        })
        .catch((err: any) => {
          setPrescriptionsList([])
          setIsLoading(false)
          console.error(err?.message)
        })
    }
  }, [medicalrecordId])

  useEffect(() => {
    if (selectedAppointment) {
      getAllTestRMO({ appointmentId: selectedAppointment })
        .then((res: any) => {
          const values = res?.testResultsList[0]
          if (values) {
            let prescriptions
            let reportsUrls: any = []
            if (values?.testResults) {
              if (Object.keys(values?.testResults)?.length > 0) {
                prescriptions = Object.keys(values?.testResults)
                prescriptions?.forEach((each: any) => {
                  const keys = Object.keys(values?.testResults[each])?.length > 0 ? Object.keys(values?.testResults[each]) : ""
                  if (keys?.includes("reportUrl")) {
                    const filenameretrieved: any = values?.testResults[each]["reportUrl"]?.substring(values?.testResults[each]["reportUrl"]?.lastIndexOf("/") + 1);
                    const filenameactual: any = filenameretrieved?.substring(filenameretrieved?.indexOf("_") + 1);
                    reportsUrls?.push({ name: filenameactual ? filenameactual : filenameretrieved, date: values?.appointmentDate, blobUrl: values?.testResults[each]["reportUrl"] })
                  }
                })
                setTestsList(reportsUrls)
              } else {
                setTestsList([])
              }
            } else {
              setTestsList([])
            }
            setIsLoading(false)
          } else {
            setTestsList([])
            setIsLoading(false)
          }
        })
        .catch((err: any) => {
          console.error("err", err)
          setTestsList([])
          setIsLoading(false)
        })
    }
  }, [selectedAppointment])

  useEffect(() => {
    if (pastAppointments?.length > 0) {
      const mappedInvoiceIds = pastAppointments?.map((appointmentId: any) => appointmentId?.invoiceId);

      const invoices_req = mappedInvoiceIds
      invoices_req?.forEach((Invoices_Id: any) => {
        setInvoices(Invoices_Id)
      })
      if (getInvoices) {
        getInvoiceDetailsById(getInvoices).then((res) => {
          setRequired(res)
        }).catch((err) => {
          console.error(err, "err")
        })
      }

    }

  }, [getInvoices, pastAppointments])

  useEffect(() => {
    if (patientId) {
      fetchSmartSummary(patientId)
    } else {
      fetchSmartSummary(userDetail?.id)
    }
  }, [userDetail])


  return (
    <div id="patientDetailWrapper" className={classes.patientDetailWrapper}>
      <div
        className={`${classes.headerSection} ${globalStyles.alignItemsCenter} d-flex`}
      >
        {patientId ? (
          <div>
            <img
              className={globalStyles.pointer}
              alt="back"
              src={"../../../assets/images/back-icon.svg"}
              width={50}
              height={50}
              onClick={() => history.push("/patientList")}
            />
          </div>
        ) : null}
        <div className={classes.patientHeaderName}>
          {PermissionUtils.displayPatientName(
            userRole,
            patientDetail,
            false,
            null
          )}
        </div>
        <div className={classes.patientId}>{patientDetail?.mocId}</div>
        {(userRole === MocUserRole.FRONT_DESK ||
          userRole === MocUserRole.PATIENT) && (
            <div className="cursor-pointer" style={{ paddingLeft: "20px" }}>
              <img
                className={globalStyles.pointer}
                src={"../../../assets/images/CRedit.svg"}
                alt="edit"
                width={24}
                height={24}
                onClick={() => history.push(`/editPatient/${patientDetail?.id}`)}

              />
            </div>
          )}
      </div>
      <div className={`col-md-12 row m-0`}>
        <div className="col-md-8 p-0">
          <PatientProfileCard
            userRole={userRole}
            patientDetail={patientDetail}
            isActive={isActive}
            isAlive={isAlive}
            isFollowup={isFollowup}
            isCalledFromDirectory={true}
            setPatientDod={(date: any) => {
              setPatientDod(date)
              toggleDisplayToast({
                text: `Are you sure you want to change the date of deceased to ${moment(date).format("DD-MM-YYYY")}?`,
                type: "error",
                onClickText: "Yes",
                onCloseText: "Close",
                dodCheck: true,
              })
            }}
            setFollowup={(evt: any) => {
              if (evt) {
                toggleDisplayToast({
                  text: "Are you sure patient has lost to follow up?",
                  type: "error",
                  onClick: (evt: any) => setFollowup(evt),
                  onClickText: "Yes",
                  onCloseText: "Close",
                  followupcheck: true,
                  textarea: "textarea"
                })

              }
            }}
            setActive={(evt: any) => {
              if (!evt) {
                toggleDisplayToast({
                  text: "Are You Sure You Want to mark the patient inactive?",
                  type: "error",
                  onClickText: "Yes",
                  onCloseText: "Close",
                  accountCheck: true,
                  textarea: "textarea"

                })
              } else {
                setActive(evt)
                onPatientAccountChange('active', "")
              }
            }}
            setAlive={(evt: any) => {
              toggleDisplayToast({
                text: evt ?
                  "Are you sure you want to mark the patient alive?" :
                  "Are you sure you want to mark the patient deceased?",
                type: evt ? "success" : "error",
                onClickText: "Yes",
                onCloseText: "Close",
                statusCheck: true,
              })
            }}
          />
        </div>
        <div className={`${globalStyles.pr0} col-md-4`}>
          <UpcomingAppointmentCarousel
            displayActionButtons={
              userRole === MocUserRole.FRONT_DESK ||
              userRole === MocUserRole.PATIENT
            }
            upcomingAppointments={upcomingAppointments}
            onCancel={(event: any) =>
              toggleDisplayToast({
                text: `Are you sure you want to cancel the appointment?`,
                type: "warning",
                onClickText: "Yes",
                patient: event,
              })
            }
            onReschedule={(event: any) =>
              toggleDisplayToast({
                text: `Clicking on reschedule will cancel the current appointment.\n Are you sure you want to continue?`,
                type: "warning",
                onClickText: "Reschedule",
                patient: event,
              })
            }
          />
        </div>

        <div className="col-md-12 m-0 p-0 ">
          <div className="mt-5">
            <div className={classes.titleName}>Visit Summary</div>
            <div className={`${classes.card} ${classes.pt21}`}>
              <div>
                <div className="d-flex">
                  <label className={classes.titleNameVisitSummary}>Diagnosis: </label>
                  <p>
                    {smartSummary?.diagnosis?.length > 0 ? (
                      <div>
                        {
                          smartSummary?.diagnosis?.map((each: any) => {
                            return (
                              <li className="values">
                                {each?.diagnosis ? each?.diagnosis : ""}&nbsp;{each?.cancerType}
                              </li>
                            )
                          })
                        }
                      </div>
                    ) : (
                      <li>NA</li>
                    )}
                  </p>
                </div>
                <div className="d-flex mt-2">
                  <label className={classes.titleNameVisitSummary}>Stage: </label>
                  <p>
                    {smartSummary?.stage?.length > 0 ? (
                      <div>
                        {
                          smartSummary?.stage?.map((each: any, index: any) => {
                            return (
                              <li className="values">
                                {getTNM(each, index)}
                              </li>
                            )
                          })
                        }
                      </div>
                    ) : (
                      <li>NA</li>
                    )}
                  </p>
                </div>
                <div className="d-flex mt-2">
                  <label className={classes.titleNameVisitSummary}>Last Visit:</label>
                  <li>{patientDetail?.lastVisit === null ? "NA" : moment(patientDetail?.lastVisit).format("DD-MM-YYYY,hh:mm")}</li>
                </div>
                <div className="d-flex mt-4">
                  <label className={classes.titleNameVisitSummary}>Total Pending Amount:</label>
                  <li>{Number(patientDetail?.totalPendingAmount)?.toFixed(2)}</li>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.appointments}>
            <div className={classes.titleName}>Past Appointments</div>
            <div className={`${classes.card} ${classes.pt21}`}>
              {pastAppointments && pastAppointments.length > 0 ? (
                pastAppointments?.map((eachPastAppointment, index) =>
                  renderAccordion(eachPastAppointment, index)
                )
              ) : (
                <div className={`${classes.noDataState}`}>
                  No past appointments.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {displayToast && (
        <><Toast
          textMessage={displayToast?.text}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={displayToast?.onClickText ? displayToast?.onClickText : null}
          textarea={displayToast?.textarea ? displayToast?.textarea : null}
          onClick={(textArea: any) => {
            return displayToast?.patient
              ? onStatusChange(
                displayToast?.patient,
                "CANCELLED",
                displayToast?.onClickText
                  ?.toLowerCase()
                  ?.includes("reschedule")
                  ? "rescheduled"
                  : ""
              )
              : displayToast?.followupcheck ? (
                onPatientFollowupChange(textArea))
                : displayToast?.statusCheck ? (
                  onPatientStatusChange()
                ) : displayToast?.accountCheck ? (
                  onPatientAccountChange("inactive", textArea)
                ) : displayToast?.dodCheck ? (
                  onPatientDODChange()
                ) : null
          }

          }
          type={displayToast?.type} /></>
      )}
      {sendPaymentLink && (
        <Toast
          textMessage={sendPaymentLink?.text}
          onClose={() => {
            setSendPaymentLink(false)
          }}
          onCloseText={"Close"}
          type={sendPaymentLink?.type}
        />
      )}
      <Modal size="xl" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>{clickOrigin === "prescriptions" ? "Prescriptions" : "Lab Reports"}</Modal.Header>
        <Modal.Body>
          <Box sx={{ marginTop: "20px" }}>
            {
              isLoading ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "50%",
                  }}
                >
                  <div
                    style={{ width: "2rem", height: "2rem" }}
                    className="spinner-border text-primary"
                  ></div>
                </div>
              ) : (
                <>
                  {
                    (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.length > 0 && (
                      <div className="d-flex justify-content-end mt-3">
                        <Button text="Download All" id="download-all" onClick={(e: any) => {
                          (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.forEach((eachItm: any, i: number) => {
                            setTimeout(function (path) {
                              fileUtils.downloadFile(path)
                            }, 300 + i * 300, eachItm);
                          })
                        }} />
                      </div>
                    )
                  }
                  < div className={classes?.docsContainer}>
                    {
                      (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.length > 0 ?
                        (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.map((ele: any) => {
                          const [name, nameStr] = ele.name.split(':');

                          return (
                            <div className={classes?.fileList}>
                              <span>
                                <FontAwesomeIcon
                                  className={classes?.docIcon}
                                  size="4x"
                                  icon={faFileAlt}
                                />
                              </span>
                              <div className={classes?.fileName}>{name}:{nameStr}&nbsp;(Date: {ele?.date ? moment(ele?.date).format("DD-MM-YYYY") : "NIL"})</div>
                              <a
                                onClick={() => fileUtils.downloadFile(ele)}
                              >
                                <FontAwesomeIcon
                                  className={classes?.downloadIcon}
                                  icon={faArrowDown}
                                />
                              </a>
                            </div>
                          )
                        })
                        :
                        <div className={`${classes.pl10} ${classes.appContentTitle}`}>
                          No data available
                        </div>
                    }
                  </div>
                </>
              )
            }
          </Box>
        </Modal.Body>
      </Modal>
    </div >
  );
}


export default PatientDetail
